import { createSlice } from '@reduxjs/toolkit';

const statusMessageSlice = createSlice({
    name: 'statusMessages',
    initialState: [],
    reducers: {
        setStatusMessages: (_state, action) => action.payload,
        addStatusMessage: (state, action) => {
            state.push(action.payload);
        },
        updateStatusMessage: (state, action) => {
            const idx = state.findIndex((r) => r.id == action.payload.id);
            if (idx !== -1) state[idx] = action.payload;
        },
        // Grid row ids are often strings; API rows use numeric ids — use loose equality.
        deleteStatusMessage: (state, action) => state.filter((r) => r.id != action.payload),
    },
});

export const { setStatusMessages, addStatusMessage, updateStatusMessage, deleteStatusMessage } = statusMessageSlice.actions;
export default statusMessageSlice.reducer;
